(function ($) {
	// nz phone number
	if (!jQuery.validator) return;

	jQuery.validator.addMethod("nzphone", function (value, element) {
		jQuery.validator.messages.nzphone = "Please enter a valid phone number - remove characters, include the prefix for landlines or international numbers.";
		return this.optional(element) || /^(\+|0)[0-9 ]{8,}$/.test(value);
	});

	if (jQuery.validator.unobtrusive) {
		jQuery.validator.unobtrusive.adapters.add("nzphone",
			function(options) {
				options.rules["nzphone"] = options.params;
				if (options.message) {
					options.messages["nzphone"] = options.message;
				}
			});
	}
}(jQuery));
